var lobbyInvites;
var lobbyInvitesItems = new Object();
var lobbyInvitesTemplate;
var lobbyRefuseAllReady = false;

/**
 * Objeto que encapsula os sons tocados
 * ao receber ou enviar convites para lobby.
 *
 * OBS: Os sons estao em "lobby-convites"
 */
var InviteSounds = {
    inviteReceived: function() {
        try { document.getElementById('soundInviteReceived').play(); } catch(err) { }
    },
    inviteRefused: function() {
        try { document.getElementById('soundInviteRefused').play(); } catch(err) { }
    },
    inviteAccepted: function() {
        try { document.getElementById('soundInviteAccepted').play(); } catch(err) { }
    }
};

// THIS FUNCTIONS DONT WILL BE USED MORE... Go to socket-gc/invites.js
function createLobbyInvite(socket)
{
    lobbyInvites = new LobbyInvite();

    $(lobbyInvites).on('connection_ok', function() {
        Object.keys(invitesFromLobby).map(function(key) {
            lobbyInvitesItems[invitesFromLobby[key].idlobby_room] = invitesFromLobby[key];
        });
        renderInvitesWidget(lobbyInvitesItems);
        $(".lobby-convites .loader-spin").show();
    }).on('reconnected', function() {
        this.getAllInvites();
        $(".lobby-convites .loader-spin").show();
    }).on('getAllInvitesAlways', function(e, data) {
        $(".lobby-convites .loader-spin").hide();
    }).on('getAllInvitesDone', function(e, data) {
        Object.keys(data.invites).map(function(key) {
            lobbyInvitesItems[data.invites[key].idlobby_room] = data.invites[key];
        });
        renderInvitesWidget(lobbyInvitesItems);
    }).on('acceptInviteDone', function(e, data) {
        window.location.href='/j/'+data.lobby.id + (data.lobby.password ? '/' + data.lobby.password:'') + '?utm_source=lobby&utm_medium=invite&utm_campaign=inbound_user_invitation';
    }).on('acceptInviteFail', function(e, data) {
        alert(data.message);
    }).on('refuseAllInvitesDone', function(e, data) {
        removeInvitesFromList(data.lobbys);
    });
}

function renderInvitesWidget(invites)
{
    if (!lobbyInvitesTemplate) {
        lobbyInvitesTemplate = document.querySelector('#lobbyInviteFromFriendsList').innerHTML;
        Mustache.parse(lobbyInvitesTemplate);
    }

    invites = Object.keys(invites).map(function(key) {
        invites[key].reputationSVGPercent = getPlayerReputation(invites[key].inviter_reputation);
        invites[key].reputationSVGColor   = getReputationColor(invites[key].inviter_reputation);
        return invites[key];
    });

    var totalInvites = invites.length;
    var plural = (totalInvites > 1);

    var rendered = Mustache.render(lobbyInvitesTemplate, {invites:invites, totalInvites:totalInvites, isPlural: plural});

    $('#lobbyConvites').html(rendered);

    if (invites.length > 0) {
        showInvitesListBox();
    }

}

function removeInviteFromList(invite)
{
    removeInvitesFromList([invite]);
}

function removeInvitesFromList(invite)
{
    for (var i = 0; i<invite.length; i++) {
        $("#lobbyInviteFriendsList-" + invite[i]).remove();
        delete lobbyInvitesItems[invite[i]];
    }

    updateInvitesCounter(Object.keys(lobbyInvitesItems).length);
}

function addInviteToList(invite)
{
    lobbyInvitesItems[invite.idlobby_room] = invite;
    renderInvitesWidget(lobbyInvitesItems);
    updateInvitesCounter(Object.keys(lobbyInvitesItems).length);
}

function updateInvitesCounter(i)
{
    $('#inviteTotalCounter').text(i);
    if (i > 0) {
        showInvitesListBox();
    } else {
        hideInvitesListBox();
    }
}

function showInvitesListBox()
{
    var item = $(".lobby-convites");

    if (!item.hasClass("lobby-convites-show")) {
        item.addClass("lobby-convites-show");
    }

    $(".lobby-convites span.close").click(function(e){
        hideInvitesListContainer();
        e.stopPropagation();
    });

    item.not("span.close").click(function(){
        if(!item.hasClass("lobby-convites-open")) {
            item.addClass("lobby-convites-open");

            setTimeout(function(){
                lobbyRefuseAllReady = true;
            }, 1000)
        }
    });

    $('.ul-convites').scrollbar({});
}

function hideInvitesListContainer(item)
{
    if (typeof item == 'undefined') {
        var item = $(".lobby-convites");
    }

    if (item.hasClass("lobby-convites-open")) {
        item.removeClass("lobby-convites-open");
    }

    lobbyRefuseAllReady = false;
}

function hideInvitesListBox()
{
    var item = $(".lobby-convites");

    if (item.hasClass("lobby-convites-show")) {
        item.removeClass("lobby-convites-show");
    }

    hideInvitesListContainer(item);
}

function acceptInviteFrom(idlobby_room,idplayer) {
    verifyForInstability(function() {
        lobbyInvites.acceptInvite(idlobby_room, idplayer);
    });
}

function refuseInviteFrom(idlobby_room,idplayer) {
    lobbyInvites.refuseInvite(idlobby_room, idplayer);
}

function refuseAllInvitesFromLobby() {
    if (lobbyRefuseAllReady) {
        lobbyInvites.refuseAllInvites();
    }
}